// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-1V3HM","content":"content-3GCop","promoImage":"promoImage-2yp4o"};